var map = {
	"./vid_body_feature1.mp4": "ce85",
	"./vid_body_feature2.mp4": "893e",
	"./vid_body_feature3.mp4": "f6e1",
	"./vid_body_feature4.mp4": "609d",
	"./vid_body_feature5.mp4": "e6f2",
	"./vid_phone_case1.mp4": "0f0d",
	"./vid_phone_case2.mp4": "073f",
	"./vid_phone_case3.mp4": "3b1d",
	"./vid_phone_case4.mp4": "8eab",
	"./vid_top_case1.mp4": "3c96",
	"./vid_top_case2.mp4": "50b3",
	"./vid_top_case3.mp4": "6af9",
	"./vid_top_case4.mp4": "98ca",
	"./vid_top_case5.mp4": "49b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bc1";